import { useState } from "react"

import {
  Box,
  ButtonBase,
  Paper,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography
} from "@mui/material"

import {
  ACTOR_META,
  JOURNEY_STEPS,
  JourneyStepId,
  SCENARIOS
} from "./guideContent"
import { ActorChip, GuideSection } from "./guideParts"

const JOURNEY_TITLE = new Map(
  JOURNEY_STEPS.map((step) => [step.id, `${step.number}. ${step.title}`])
)

export default function ScenariosSection({
  onJourneyStep
}: {
  onJourneyStep: (id: JourneyStepId) => void
}) {
  const [scenarioId, setScenarioId] = useState(SCENARIOS[0].id)
  const scenario =
    SCENARIOS.find((item) => item.id === scenarioId) || SCENARIOS[0]

  return (
    <GuideSection
      id="scenarios"
      eyebrow="Uygulamada"
      title="Örnek senaryolar"
      lead="Aynı akışı gerçek konuşmalar üzerinden takip edin. Her satırda kimin ne yaptığı ve yolculuğun hangi adımında olunduğu yazıyor; adıma tıklarsanız yukarıda o adımın açıklaması açılır."
    >
      <ToggleButtonGroup
        exclusive
        size="small"
        value={scenario.id}
        onChange={(_event, value: string | null) =>
          value && setScenarioId(value)
        }
        sx={{ mb: 2, flexWrap: "wrap" }}
      >
        {SCENARIOS.map((item) => (
          <ToggleButton
            key={item.id}
            value={item.id}
            sx={{ textTransform: "none", fontWeight: 800, px: 2 }}
          >
            {item.title}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>

      <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
        <Typography variant="body1" sx={{ mb: 2.5 }}>
          {scenario.lead}
        </Typography>
        <Stack component="ol" sx={{ m: 0, p: 0, listStyle: "none" }}>
          {scenario.steps.map((step, index) => {
            const color = ACTOR_META[step.actor].color
            const isLast = index === scenario.steps.length - 1
            return (
              <Stack
                component="li"
                key={`${scenario.id}-${index}`}
                direction="row"
                spacing={2}
              >
                <Stack alignItems="center" sx={{ width: 28, flex: "0 0 auto" }}>
                  <Box
                    sx={{
                      width: 28,
                      height: 28,
                      borderRadius: "50%",
                      border: `2px solid ${color}`,
                      color,
                      fontWeight: 900,
                      fontSize: 12,
                      display: "grid",
                      placeItems: "center",
                      bgcolor: "background.paper"
                    }}
                  >
                    {index + 1}
                  </Box>
                  {!isLast && (
                    <Box
                      sx={{ flex: 1, width: 2, bgcolor: "divider", my: 0.5 }}
                    />
                  )}
                </Stack>
                <Box sx={{ pb: isLast ? 0 : 2.5, minWidth: 0 }}>
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    flexWrap="wrap"
                    useFlexGap
                    sx={{ mb: 0.5 }}
                  >
                    <ActorChip actor={step.actor} />
                    <ButtonBase
                      onClick={() => onJourneyStep(step.journey)}
                      sx={{
                        typography: "caption",
                        color: "text.secondary",
                        textDecoration: "underline",
                        borderRadius: 0.5
                      }}
                    >
                      {JOURNEY_TITLE.get(step.journey)}
                    </ButtonBase>
                  </Stack>
                  <Typography variant="body2" sx={{ lineHeight: 1.55 }}>
                    {step.text}
                  </Typography>
                </Box>
              </Stack>
            )
          })}
        </Stack>
      </Paper>
    </GuideSection>
  )
}
